import { useEffect, useState } from 'react';

// Appears only after `delay` ms (default 300), so a fast load shows nothing
// instead of a flashing spinner. delay={0} shows it at once.
export function LoadingSpinner({ size = 24, delay = 300 }: { size?: number; delay?: number }) {
  const [shown, setShown] = useState(delay <= 0);
  useEffect(() => {
    if (delay <= 0) return;
    const t = setTimeout(() => setShown(true), delay);
    return () => clearTimeout(t);
  }, [delay]);
  if (!shown) return null;
  return (
    <div
      className="inline-block border-2 border-slate-300 border-t-primary rounded-full animate-spin"
      style={{ width: size, height: size }}
      role="status"
      aria-label="Loading"
    />
  );
}
